import { Component } from '@angular/core';

@Component({
  selector: 'greco-variant-picker',
  templateUrl: './variant-picker.component.html',
  styleUrls: ['./variant-picker.component.scss'],
})
export class VariantPickerComponent {}
